import {
  DASHBOARD_APP_NAME,
  DASHBOARD_CLIENT_KEY,
  FEATURE_LABORATORY_DEVELOPMENT_URL,
  FEATURE_LABORATORY_PRODUCTION_URL,
} from '@/utils/constants/featureLaboratory'
import { type IConfig, UnleashClient } from 'unleash-proxy-client'

const unleashClientKey: IConfig = {
  appName: DASHBOARD_APP_NAME,
  clientKey: DASHBOARD_CLIENT_KEY,
  environment: import.meta.env.PROD ? 'production' : 'development',
  url: import.meta.env.PROD
    ? FEATURE_LABORATORY_PRODUCTION_URL
    : FEATURE_LABORATORY_DEVELOPMENT_URL,
}

export const unleashClient = new UnleashClient(unleashClientKey)
